import script from "./ResourceUnsupported.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceUnsupported.vue?vue&type=script&setup=true&lang=ts"

import "./ResourceUnsupported.vue?vue&type=style&index=0&id=61107832&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@5.9.3__webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61107832"]])

export default __exports__